import React, {ReactNode} from 'react';

import {
  cats,
  withShortcuts,
  WithShortcutsProps,
} from 'app/general/shortcuts/withShortcuts';
import {gt} from 'app/utils/i18n';

interface Props extends WithShortcutsProps {
  stepsIds: Array<string>;
  children: (args: {
    collapsedSteps: Record<string, boolean>;
    numCollapsedSteps: number;
    toggleStepCollapse: (id: string, collapse: boolean | null) => void;
    toggleAllStepsCollapse: (collapse: boolean) => void;
  }) => ReactNode;
}

type State = {
  collapsedSteps: Record<string, boolean>;
};

export class BaseCollapsedStepsState extends React.Component<Props, State> {
  state = {
    collapsedSteps: {},
  };

  componentDidMount(): void {
    const {enableShortcut} = this.props;
    enableShortcut('[', () => this.toggleAllStepsCollapse(false));
    enableShortcut(']', () => this.toggleAllStepsCollapse(true));
    // it's a hack to render the component again after all refs
    // was resolved
    this.setState({});
  }

  toggleAllStepsCollapse = (collapse: boolean): void => {
    const {stepsIds} = this.props;
    this.setState({
      collapsedSteps: stepsIds.reduce((steps, id) => {
        steps[id] = collapse;
        return steps;
      }, {}),
    });
  };
  toggleStepCollapse = (id: string, collapse: boolean | null): void => {
    this.setState({
      collapsedSteps: {...this.state.collapsedSteps, [id]: collapse},
    });
  };

  getNumCollapsedSteps(): number {
    return Object.keys(this.state.collapsedSteps).reduce(
      (count, key) => count + (this.state.collapsedSteps[key] === true ? 1 : 0),
      0
    );
  }

  render(): ReactNode {
    const {children} = this.props;
    const {collapsedSteps} = this.state;
    return children({
      collapsedSteps,
      numCollapsedSteps: this.getNumCollapsedSteps(),
      toggleAllStepsCollapse: this.toggleAllStepsCollapse,
      toggleStepCollapse: this.toggleStepCollapse,
    });
  }
}

export const CollapsedStepsState = withShortcuts<Props>([
  {
    key: '[',
    name: () => gt('Expand all procedure steps'),
    category: cats.detailPage,
  },
  {
    key: ']',
    name: () => gt('Collapse all procedure steps'),
    category: cats.detailPage,
  },
])(BaseCollapsedStepsState);
